import Cookies from "js-cookie";

/**
 * TODO : Remove this polyfill when polyfill.io will fix the Array.from issue
 * @see https://github.com/Financial-Times/polyfill-service/issues/1209
 */
import "core-js/fn/array/from";
import pym from 'pym.js' // should be imported after LazyLoad and before LazyLoadHtml

import './dropdown/Dropdown';
import tippy from "tippy.js";

import "./lib/owl.carousel.min"; 
import Tracking from "./analytics/Tracking";


import Analytics from './analytics/analytics';

import pictureFill from "picturefill/dist/picturefill";
import touch from "./utils/Touch";
import BrowserDetect from "./utils/BrowserDetect";
import ObjectFitImages from "object-fit-images";



// Make pym available in global (used by wort immo module and others stuff...)
window.pym = pym;
window.Analytics = Analytics;

// Since setting cookie with fingerprint is async and gtm events are async, we make this func global to be able to call it directly from gtm in response to triggers
// ex: to be sure that the cookie is set when we call /api/trk on a Page View event
window.setTrackingCookie = Tracking.setTrackingCookie;

if(window.logJsErrors) {
    require('./utils/JsErrorLogging');
}

if(!window.isPreview) {
    require("./lib/analytics/mwTag");
    require("./lib/analytics/spring");
}

const lang = document.documentElement.lang || "de";

Cookies.get('language', lang, { expires: 1825, path: '/' }); // to remember, for 5 years, the latest visited edition

if (Cookies.get('eu_law_accept') !== "true") {
    $('#cookie-bar').show("slow");

    $('#cookie-bar').on("click",".button_close",function() {
        Cookies.get('eu_law_accept',"true", { expires: 365 }); // to remember, for 1 year, the cookie policy display
        $('#cookie-bar').hide("slow");
    });
}

/**
 * Log user actions done on dynamic content
 */

window.logAction = function() {
    var splittedUrl = window.location.pathname.split('/');

    var langFromUrl = splittedUrl[1] !== undefined ?splittedUrl[1]:'de';
    var section = splittedUrl[2];
    var trafficTag = splittedUrl[3] !== undefined ?splittedUrl[3]:'';
    var articleId;

    if (langFromUrl === 'mywort') {
        langFromUrl = 'de';
        section = 'mywort';
    }

    if (section !== undefined) {
        if (section !== 'service') {
            articleId = window.location.pathname.split('-').pop();
            trafficTag = section;
            section = 'news';
        }
    } else {
        section = 'news';
        trafficTag = 'home';
    }

    var url = '/api/v304/sites/'+langFromUrl+'/analytic/'+section+'/'+trafficTag+'?devicetype=browser' + (articleId ? '&id='+articleId:'');
    var iframe = '<iframe src="'+url+'" scrolling="no" style="border:0; width:0; height:0;"></iframe>';

    $('#logAction').html(iframe);
};


/**
 * Search bar
 */
function installSearch() {

    function triggerSearch(text) {
        if(text.toLowerCase()==='am ale wort') {
            $('.logo').empty().append('« am ale Wort »');
            $("<link/>", {
                rel: "stylesheet",
                type: "text/css",
                href: "https://isp-public.s3.amazonaws.com/eegg/custom.css"
            }).appendTo("head");

            $('.today__info').text($('.today__info').text().replace(/[0-9]{4}/, "1848"));
            $('.footer-legal__text').text($('.footer-legal__text').text().replace(/[0-9]{4}/, "1848"));
            $(".search-bar").find('input').blur().val('');
            $("#navbar-menu-search, #mobile-navbar-menu-search").removeClass("mobile-search--active menu__list__item__link--active");
            $(".search-bar").removeClass('search-bar--search');
        } else {
            if (text && text.length > 0) {
                const query = encodeURIComponent(text);
                let urlParams = window.location.href;
                if(urlParams && urlParams.indexOf("latina")>=0) {
                    window.location = `/${lang}/search/${query}?identity=latina`;
                } else {
                    window.location = `/${lang}/search/${query}`;
                }
            }
        }
    }

    $('.search-button, .mobile-search.menu__list__item__link--active').click(function() {
        const inputId = $(this).attr('data-search-input');
        if(inputId) {
            const text = $(`#${inputId}`).val();
            triggerSearch(text);
        }
        return false;
    });
}

/**
 * Put a target="_blank" to all external links
 */
function initExternalLinks() {
    /**
     * Returns true if at least one item of matchArray match the beginning of str
     */
    function startsWithAny(str, matchArray) {
        for(let i = 0; i < matchArray.length; i++) {
            if(str.indexOf(matchArray[i]) === 0) {
                return true;
            }
        }
        return false;
    }
    /**
     * Returns true if the link is external
     */
    function isExternalLink(href) {
        if(href === "") {
            return false;
        }
        const internalMatches = ['#', 'javascript:', 'mailto:', 'tel:', `https://${window.location.hostname}`, `https://${window.location.hostname.replace("www.", "")}`, `http://${window.location.hostname}`] ;
        if(startsWithAny(href, internalMatches)) {
            return false;
        }
        return true;
    }
    $('a:not(.internal-link)').each(function () {
        if (isExternalLink(this.href)) {
            $(this).attr('rel', 'noopener');
            $(this).attr('target', '_blank');
        }
    });
}

function initCoverItLive() {
    var coverItLiveId = $('.coveritlive-embed').data('coveritlive-id');
    $(".coveritlive-embed").append($("<script />", {
        html: "window.cilAsyncInit = function() { cilEmbedManager.init() }; (function() { if (window.cilVwRand === undefined) { window.cilVwRand = Math.floor(Math.random()*10000000); } var e = document.createElement('script'); e.async = true; var domain = (document.location.protocol == 'http:') ? '//cdnsl.coveritlive.com' : '//cdnslssl.coveritlive.com'; e.src = document.location.protocol + domain + '/vw.js?v=' + window.cilVwRand; e.id = 'cilScript-"+coverItLiveId+"'; document.getElementById('cil-root-"+coverItLiveId+"').appendChild(e); }());"
    }))
}

function initDatalayer() {
    $('article[data-article-pos]').each(function () {

        const dataPos = this.getAttribute("data-article-pos");

        $('a', this).each(function () {

            $(this).click(function () {

                if (window.dataLayer) {

                    let dataArticleUrl = `${window.location.protocol}//${window.location.hostname}`;

                    if(window.location.port) {
                        dataArticleUrl += `:${window.location.port}`;
                    }

                    dataArticleUrl += $(this).attr('href');

                    window.dataLayer.push({
                        'data-article-pos': dataPos,
                        'event' : 'ArticlePosition',
                        'data-article-url': dataArticleUrl
                    });
                }
            });
        });
    });

}

window.iOSIFrameFixWidth = function() {
    // Adjust width on iOS for specific iframes
    if(BrowserDetect.isIOS()) {
        let iframes = document.querySelectorAll('[data-iframe-ios-fix] iframe');
        iframes.forEach(iframe => {
            iframe.setAttribute('scrolling', 'no');
            iframe.setAttribute('width', '1');
            iframe.setAttribute("class", "ios-iframe-fix");
        });
    }
}

// on iOS, we replace 360 videos by a link as they're not supported yet by Safari
window.iOSVideos360Fix = function() {
    if(BrowserDetect.isIOS()) {
        let videos360 = document.querySelectorAll('.video-360');
        if(videos360.length>0) {
            // if the user doesn't have the Youtube App installed, Safari shows an error.
            // this is  a custom callback to propose to the user to go to the app store to download Youtube.

            // To avoid the "protocol not supported" alert, fail must open another app.
            let appstorefail = "itms-apps://itunes.apple.com/us/app/youtube-watch-listen-stream/id544007664?l=en&mt=8";

            let appLinkfn = function applink(fail) {
                return function () {
                    let clickedAt = +new Date;
                    // During tests on 3g/3gs this timeout fires immediately if less than 500ms.
                    setTimeout(function () {
                        // To avoid failing on return to MobileSafari, ensure freshness!
                        if (+new Date - clickedAt < 2000) {
                            window.location = fail;
                        }
                    }, 500);
                };
            };

            document.getElementById("youtube-app-link").onclick = appLinkfn(appstorefail);
        }
        videos360.forEach(video360 => {
            video360.classList.add("video-360--ios")
        });
    }
}

// following block will be executed on document ready
$(function() {
});



// WEBPACK FOOTER //
// ./js/bootstrap.js